import { render } from "./OrderTicketSummaryCard.vue?vue&type=template&id=97798004"
import script from "./OrderTicketSummaryCard.vue?vue&type=script&lang=js"
export * from "./OrderTicketSummaryCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__